import mitt from 'mitt'
const emitter = mitt()

export default function useEmit() {
  return emitter
}
